import {
  delete_quick_addr,
  delivery_man_info,
  insert_quick_addr,
  requestCustomerMemoDelete,
  requestCustomerMemoRegister,
  requestKitchenMemoDelete,
  requestKitchenMemoRegister,
  select_quick_addr,
  update_shop_view_order,
  outAutoUpdate,
  deliveryUseUpdate,
  fn_change_prit_receipt,
  fn_setting_prit_receipt,
  fn_return_success,
} from "../http/SettingConn";
import { origin_info_item, origin_info_item_save } from "http/DetailConn";
import {
  fn_bridge_helpu_popup,
  fn_bridge_naver_popup,
  fn_bridge_pdf_popup,
  fn_bridge_print_action,
  fn_bridge_shopinfo_set,
  fn_bridge_print_confirm,
  fn_bridge_payfree_popup,
  fn_bridge_log,
  fn_bridge_receipt_test,
  fn_bridge_order_cancel_pos,
  fn_bridge_agency_popup,
} from "./FnPosBridge";
import { select_access_token } from "../http/TokenConn";
import { main_dlv } from "http/dlvCommonConn";
import { analyticeEvent } from "utils/Utils";

/**
 * 셋팅페이지 함수.
 */

export function fn_change_init_view(rootStore) {
  rootStore.settingStore.setInitView("Y");
  fn_bridge_shopinfo_set(rootStore);
}

// view 타입 수정
export function fn_change_view_type(rootStore, value) {
  rootStore.settingStore.setSettingDefaultViewObj("viewType", value);
  fn_bridge_shopinfo_set(rootStore);
}

// view 정렬 수정
export function fn_change_view_order(rootStore, value) {
  rootStore.settingStore.setSettingDefaultViewObj("viewOrder", value);
  fn_bridge_shopinfo_set(rootStore);
}

// 사운드 증가
export function fn_change_up_sound(rootStore) {
  let curr_sound = Number(rootStore.settingStore.getSoundPlayInfo.soundLevel);
  if (curr_sound === 5) return;
  curr_sound = curr_sound + 1;
  //rootStore.settingStore.setSettingDefaultViewObj('soundLevel', curr_sound);
  rootStore.settingStore.setSoundPlayCheck("soundLevel", curr_sound);
  fn_bridge_shopinfo_set(rootStore);
}

// 사운드 다운
export function fn_change_down_sound(rootStore) {
  let curr_sound = Number(rootStore.settingStore.getSoundPlayInfo.soundLevel);
  if (curr_sound === 0) return;
  curr_sound = curr_sound - 1;
  //rootStore.settingStore.setSettingDefaultViewObj('soundLevel', curr_sound);
  rootStore.settingStore.setSoundPlayCheck("soundLevel", curr_sound);
  fn_bridge_shopinfo_set(rootStore);
}

// 배달,픽업,테이블 자동접수 여부 수정
export function fn_change_auto_accept(rootStore, key) {
  const settingStore = rootStore.settingStore;
  let val = "N";
  if (key === "delivery") {
    key = "autoAcceptDelivery";
    val = settingStore.getAutoAcceptDelivery === "Y" ? "N" : "Y";
  } else if (key === "pickup") {
    key = "autoAcceptPickup";
    val = settingStore.getAutoAcceptPickup === "Y" ? "N" : "Y";
  } else if (key === "table") {
    key = "autoAcceptTable";
    val = settingStore.getAutoAcceptTable === "Y" ? "N" : "Y";
  }

  rootStore.settingStore.setSettingDefaultViewObj(key, val);

  select_access_token(rootStore).then(res => {
    update_shop_view_order(rootStore);
  });
}

export function fn_change_df_time(rootStore, key, type) {
  const settingStore = rootStore.settingStore;
  const time = ["0", "5", "10", "15", "20", "30", "45", "60", "70", "80", "90", "120"];
  let val = "0";
  let cnt = 0;

  if (key === "delivery") {
    key = "deliveryDfTime";
    val = settingStore.getDeliveryDfTime ? settingStore.getDeliveryDfTime : "0";
  } else if (key === "cooking") {
    key = "cookingDfTime";
    val = settingStore.getCookingDfTime ? settingStore.getCookingDfTime : "0";
  }

  time.map((item, index) => {
    if (val == item) {
      if (val != "120" && type === "up") {
        cnt = index + 1;
      } else if (val != "0" && type === "down") {
        cnt = index - 1;
      }
    }
  });

  rootStore.settingStore.setSettingDefaultViewObj(key, time[cnt]);
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_change_df_pickup(rootStore, type) {
  let dfTime = rootStore.settingStore.getPickupDfTime;

  rootStore.deliveryStore.getDeliveryFee.pick_arr.map((time, index) => {
    if (
      dfTime === time &&
      type === "up" &&
      index < rootStore.deliveryStore.getDeliveryFee.pick_arr.length &&
      index != 7
    ) {
      rootStore.settingStore.setPickupDfTime(rootStore.deliveryStore.getDeliveryFee.pick_arr[index + 1]);
      fn_bridge_shopinfo_set(rootStore);
    }

    if (
      dfTime === time &&
      type === "down" &&
      index < rootStore.deliveryStore.getDeliveryFee.pick_arr.length &&
      index != 0
    ) {
      rootStore.settingStore.setPickupDfTime(rootStore.deliveryStore.getDeliveryFee.pick_arr[index - 1]);
      fn_bridge_shopinfo_set(rootStore);
    }
  });
}

// 자동 주문 접수
export async function fn_change_auto_accept_flag(rootStore, value) {
  await rootStore.settingStore.setSettingDefaultViewObj("autoAcceptFlag", value);
  fn_bridge_shopinfo_set(rootStore);
}

// 메뉴탭 보이기 안보이기 설정.
export function fn_show_setting(rootStore, viewBl) {
  rootStore.settingStore.setSettingView(viewBl);
}

// 퀵 주소 정보 조회
export function fn_select_quick_addr(rootStore) {
  select_access_token(rootStore).then(res => {
    select_quick_addr(rootStore);
  });
}

// 퀵 주소 등록
export function fn_insert_quick_addr(rootStore) {
  if (rootStore.settingStore.getQuickAddrCurr == null || rootStore.settingStore.getQuickAddrCurr == "") {
    return false;
  }

  select_access_token(rootStore).then(res => {
    insert_quick_addr(rootStore);
  });
}

// 퀵 주소 삭제
export function fn_delete_quick_addr(rootStore, seq) {
  select_access_token(rootStore).then(res => {
    delete_quick_addr(rootStore, seq);
  });
}

export function fn_open_manual(rootStore) {
  //let manualPop
  //manualPop = window.open("https://okgo.okpos.co.kr/OKPOS_USERMANUAL_V1.4_20220420.pdf", "manualPop", "toolbar=no, width=1024, height=768, directories=no, status=no, scrollorbars=no, resizable=no, left=0, top=0")
  //manualPop.focus()
  //fn_bridge_close(rootStore)

  fn_bridge_pdf_popup(rootStore);
}

export function fn_open_help(rootStore) {
  //let helpPop
  //helpPop = window.open("https://helpu.kr/okpos01/", "helpPop", "toolbar=no, width=1024, height=768, directories=no, status=no, scrollorbars=no, resizable=no, left=0, top=0")
  //helpPop.focus()
  fn_bridge_helpu_popup(rootStore);
}

//주방출력사용해보기
export function fn_payfree_info(rootStore, link, btn) {
  fn_bridge_payfree_popup(rootStore, link, btn);
}

//문의접수
export function fn_cs_pop(rootStore) {
  analyticeEvent("cs", "csVoc Button", rootStore.searchStore.getShopCd); //GA4
  //문의팝업open
  rootStore.layerStore.setLayerCsView(true);
}

//사용안내
export function fn_guide_pop(rootStore) {
  analyticeEvent("cs", "csGuide Button", rootStore.searchStore.getShopCd); //GA4
  //사용안내open
  rootStore.layerStore.setLayerOnboardingView(true);
}

//로그전송
export function fn_send_log(rootStore) {
  fn_bridge_log(rootStore, false);
}

// 네이버 설정 호출
export function fn_open_naver_setting(rootStore) {
  //let naverPop;
  //const settingStore = rootStore.settingStore;
  //const searchStore = rootStore.searchStore;
  /*
    if (settingStore.getActive === 'dev') {
        naverPop = window.open("https://tdum.okpos.co.kr/asp/naver_pop/pop?popShopCd=" + encodeURIComponent(searchStore.getShopCd), "naverPop", "toolbar=no, width=1024, height=768, directories=no, status=no, scrollorbars=no, resizable=no, left=0, top=0");
    } else if (settingStore.getActive === 'staging') {
        naverPop = window.open("https://sdum.okpos.co.kr:8443/asp/naver_pop/pop?popShopCd=" + encodeURIComponent(searchStore.getShopCd), "naverPop", "toolbar=no, width=1024, height=768, directories=no, status=no, scrollorbars=no, resizable=no, left=0, top=0");
    } else if (settingStore.getActive === 'real') {
        naverPop = window.open("https://dum.okpos.co.kr:8443/asp/naver_pop/pop?popShopCd=" + encodeURIComponent(searchStore.getShopCd), "naverPop", "toolbar=no, width=1024, height=768, directories=no, status=no, scrollorbars=no, resizable=no, left=0, top=0");
    }
    naverPop.focus()
    */

  //fn_bridge_close(rootStore)

  fn_bridge_naver_popup(rootStore);
}

//자체배달원 등록
export function fn_deliverySelfInput(rootStore) {
  select_access_token(rootStore).then(res => {
    delivery_man_info(rootStore).then(res => {
      if (res) {
        rootStore.deliveryStore.initDeliveryAspForm();
      }
      rootStore.layerStore.setLayerDeliverySelfView(false);
    });
  });
}

export function fn_getDefaultSelectedComport(rootStore) {
  let comport = rootStore.settingStore.getPrinterInfo.usedComPortForHooking;

  if (comport == "" || comport == null || comport == "null") {
    return "연결할 포트를 선택해주세요";
  }

  let list = rootStore.settingStore.getPrinterInfo.availableComPorts;
  let result = list.map((element, index) => {
    if (element.portNo == comport) {
      return element.portName;
    }
    return "";
  });

  return result;
}

export function fn_getSelectedComport(rootStore, type) {
  if (type == "port1") {
    if (rootStore.settingStore.getPrinterInfo.usedVirtualModeVPrint1 == "") {
      return "가상 포트1";
    } else {
      return rootStore.settingStore.getPrinterInfo.usedVirtualModeVPrint1;
    }
  } else if (type == "port2") {
    if (rootStore.settingStore.getPrinterInfo.usedVirtualModeVPrint2 == "") {
      return "가상 포트2";
    } else {
      return rootStore.settingStore.getPrinterInfo.usedVirtualModeVPrint2;
    }
  } else if (type == "printPort") {
    if (rootStore.settingStore.getPrinterInfo.usedVirtualModePrintPort == "") {
      return "출력 포트";
    } else {
      return rootStore.settingStore.getPrinterInfo.usedVirtualModePrintPort;
    }
  }
}

export function fn_getSelectedBaudrate(rootStore) {
  let baudRate = rootStore.searchStore.getPrintAddSelectBaudRate;

  if (baudRate.length == 0 || rootStore.settingStore.getPrinterInfo.usedVirtualModePrintBaudrate == "") {
    return "출력 속도";
  } else {
    return rootStore.settingStore.getPrinterInfo.usedVirtualModePrintBaudrate;
  }
}

export function fn_setDefaultSelectedComport(rootStore, port) {
  if (fn_getPrinterCheck(rootStore, port, null, "P")) {
    rootStore.settingStore.setUsedComport(port);
    fn_setDefaultComportListView(rootStore, false);
    fn_bridge_shopinfo_set(rootStore);
  }
}

export function fn_setSelectedComport(rootStore, port, type) {
  if (type == "port1") {
    rootStore.settingStore.setCheckPrintPortType1(port);
  } else if (type == "port2") {
    rootStore.settingStore.setCheckPrintPortType2(port);
  } else if (type == "printPort") {
    rootStore.settingStore.setCheckModePrintPortType(port);
  } else if (type == "baudrate") {
    rootStore.settingStore.setCheckModePrintBaudrate(port);
  }
  fn_setComportListView(rootStore, type, !fn_getComportListView(rootStore, type));
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_setSelectedBaudrate(rootStore, port) {
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_getPrinterCheck(rootStore, port, kitchen, type) {
  let breakFlag = true;
  let comport = type == "P" ? port : rootStore.settingStore.getPrinterInfo.usedComPortForHooking;
  let kitchenUsedInfo = type == "P" ? rootStore.settingStore.getPrinterInfo.usedKitchenPrinterCodes : kitchen;
  let kitchenInfo = rootStore.settingStore.getPrinterInfo.kitchenPrinterSettings;
  let connPosNo = rootStore.searchStore.getSession.connPosNo;

  if (comport == "" || comport == null || comport == "null" || kitchenUsedInfo.length <= 0) {
    return true;
  }

  for (let i = 0; i < kitchenUsedInfo.length; i++) {
    for (let j = 0; j < kitchenInfo.length; j++) {
      if (kitchenUsedInfo[i] == kitchenInfo[j].printerCode) {
        if (connPosNo == kitchenInfo[j].posNo && comport == kitchenInfo[j].comPort) {
          breakFlag = false;
          break;
        }
      }
    }
  }

  if (!breakFlag) {
    rootStore.layerStore.setLayerAlertType("printer_same_not_setting");
    rootStore.layerStore.setLayerAlertView(true);
  }

  return breakFlag;
}

export function fn_setTestPrint(rootStore, type, setting, setVal, rate, printerCode) {
  let command;
  let printInfo;
  let viewCheck;
  let alertKitchenCheck;
  rootStore.settingStore.setEtcPrinterInfoConfirm(false);
  if (rate == undefined) rate = "";
  if (printerCode == undefined) printerCode = "";
  rate = rate.trim();

  if (type == "P") {
    if (setting == "etc") {
      rootStore.settingStore.setEtcPrinterInfoConfirm(true);
      printInfo = setVal;
    } else {
      printInfo = rootStore.settingStore.getPrinterInfo.usedComPortForHooking;
    }

    command = "ORDER_PRINT";
    viewCheck = printInfo == "" || printInfo == null || printInfo == "null" ? false : true;
  } else {
    printInfo = rootStore.settingStore.getPrinterInfo.usedKitchenPrinterCodes;
    command = "KITCHEN_PRINT";
    viewCheck = printInfo.length <= 0 ? false : true;

    alertKitchenCheck = viewCheck;
  }

  if (!viewCheck) {
    rootStore.layerStore.setLayerAlertType("printer_set_view");
    rootStore.layerStore.setLayerAlertView(true);
    return;
  }

  if (alertKitchenCheck) {
    rootStore.layerStore.setLayerAlertType("print_delay");
    rootStore.layerStore.setLayerAlertView(true);
  }

  if (type == "P") {
    rootStore.layerStore.setLayerAlertType("printer_action_view");
    rootStore.layerStore.setLayerAlertView(true);
  }

  fn_bridge_print_action(rootStore, command, printInfo, rate, printerCode);
}

export function fn_print_confirm(rootStore) {
  if (!rootStore.settingStore.getEtcPrinterInfoConfirm) {
    rootStore.layerStore.setLayerAlertType("printer_action_confirm");
    rootStore.layerStore.setLayerAlertView(true);
    fn_bridge_print_confirm(rootStore);
  }
}

export function fn_setSelectedKitchen(rootStore, kitchenNo, checked) {
  let tempKitchenArr = [];

  tempKitchenArr.push(kitchenNo);

  if (!fn_getPrinterCheck(rootStore, null, tempKitchenArr, "K")) {
    return false;
  }

  if (checked == true) {
    if (rootStore.settingStore.getPrinterInfo.usedKitchenPrinterCodes.indexOf(kitchenNo) <= 0) {
      rootStore.settingStore.getPrinterInfo.usedKitchenPrinterCodes.push(kitchenNo);
    }
  } else if (checked == false) {
    let filtered = rootStore.settingStore.getPrinterInfo.usedKitchenPrinterCodes.filter(
      element => element !== kitchenNo
    );
    rootStore.settingStore.getPrinterInfo.usedKitchenPrinterCodes = filtered;
  }

  fn_bridge_shopinfo_set(rootStore);
}

export function fn_setComportListView(rootStore, type, viewBl) {
  rootStore.settingStore.setComportSelectInitView();
  rootStore.settingStore.setComportSelectView(type, viewBl);
}

export function fn_getComportListView(rootStore, type) {
  return rootStore.settingStore.getComportSelectView[type];
}

export function fn_setDefaultComportListView(rootStore, viewBl) {
  rootStore.settingStore.setDefaultComportSelectView(viewBl);
}

export function fn_getDefaultComportListView(rootStore) {
  return rootStore.settingStore.getDefaultComportSelectView;
}

export function fn_setHookingFlag(rootStore, viewBl) {
  rootStore.settingStore.setCheckHooking(viewBl);
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_getHookingFlag(rootStore) {
  return rootStore.settingStore.getCheckHooking == "Y" ? true : false;
}

export function fn_setOutPrinterFlag(rootStore, viewBl) {
  rootStore.settingStore.setOriginSettingInfoYn(viewBl);
  origin_info_item_save(rootStore);
}

export function fn_getOutPrinterFlag(rootStore) {
  return rootStore.settingStore.getOriginSettingInfo.originInfoYn == "Y" ? true : false;
}

export function fn_setOriginInfo(rootStore) {
  origin_info_item(rootStore);
  rootStore.layerStore.setLayerOriginView(true);
}

export function fn_setTestPrintOut(rootStore) {
  let cnt = 0;

  if (rootStore.settingStore.getEtcPrinterInfo.defaultPrintSettings.length > 0) {
    rootStore.settingStore.getEtcPrinterInfo.defaultPrintSettings.map(obj => {
      if (obj.printerName == "영수프린터" && obj.useYn == "Y") {
        cnt = 1;
      }
    });
  }

  if (rootStore.settingStore.getEtcPrinterInfo.addPrintSettings.length > 0) {
    rootStore.settingStore.getEtcPrinterInfo.addPrintSettings.map(obj => {
      if (obj.useYn == "Y") {
        cnt = 1;
      }
    });
  }

  if (rootStore.settingStore.getPrinterInfo.etcPrinterFlag == "N") {
    cnt = 0;
  }

  if (cnt >= 1) {
    fn_bridge_receipt_test(rootStore);
  } else {
    rootStore.layerStore.setLayerPrintSetType("test");
    rootStore.layerStore.setLayerAlertType("print_setting");
    rootStore.layerStore.setLayerAlertView(true);
  }
}

export function fn_setTestPrintOutChange(rootStore, module, type, item, val) {
  let list = [];

  if (type == "HALL") {
    rootStore.settingStore.setPrintOutReceipt0(item, val);
    list = rootStore.settingStore.getPrintOutListHall;
  } else if (type == "KITCHEN") {
    rootStore.settingStore.setPrintOutReceipt1(item, val);
    list = rootStore.settingStore.getPrintOutListKitchen;
  }

  list.map((obj, index) => {
    if (obj.receiptModule == module) {
      obj.receiptStyle[item] = val;
    }

    //연락처 설정 시 고객명 동시 설정
    if (obj.receiptModule == "DELIVERY_ADDRESS" && module == "TEL_NO" && item == "phone") {
      obj.receiptStyle.customerNm = val;
    }

    //매안매뉴 설정 시 배달팁 동시 설정
    if (obj.receiptModule == module && module == "MENU" && item == "menu") {
      obj.receiptStyle.deliveryFee = val;
    }
  });
  fn_change_prit_receipt(rootStore, list);
}

export function fn_printOutInit(rootStore) {
  rootStore.layerStore.setLayerAlertType("print_out_init");
  rootStore.layerStore.setLayerAlertView(true);
}

export function fn_printOutInitChange(rootStore) {
  let list = [];

  if (rootStore.layerStore.getPrintOutType == "HALL") {
    rootStore.settingStore.setPrintOutListHall();
    rootStore.settingStore.initPrintOutReceipt0();
    fn_setting_prit_receipt(rootStore, rootStore.layerStore.getPrintOutType, "DEFAULT").then(r => {
      fn_change_prit_receipt(rootStore, rootStore.settingStore.getPrintOutListHall);
    });
  } else if (rootStore.layerStore.getPrintOutType == "KITCHEN") {
    rootStore.settingStore.setPrintOutListKitchen();
    rootStore.settingStore.initPrintOutReceipt1();
    fn_setting_prit_receipt(rootStore, rootStore.layerStore.getPrintOutType, "DEFAULT").then(r => {
      fn_change_prit_receipt(rootStore, rootStore.settingStore.getPrintOutListKitchen);
    });
  }
}

export function fn_initOutPrinter(rootStore) {
  rootStore.settingStore.setOriginSettingInfo("originInfo", "");
  rootStore.layerStore.setLayerOriginView(false);
  rootStore.layerStore.setScrollDisabled("up", true);
  document.getElementById("boxScroll").scrollTo(0, 0);
}

export function fn_setManagerSetFlag(rootStore, type, viewBl) {
  let flag = "";
  if (type == "salePage") {
    if (viewBl == "Y") {
      flag = "N";
    } else {
      flag = "Y";
    }
  } else if (type == "saleMenuShow") {
    if (viewBl == "Y") {
      flag = "N";
    } else {
      flag = "Y";
    }
  } else {
    if (viewBl == "Y") {
      flag = "N";
    } else {
      flag = "Y";
    }
  }
  rootStore.settingStore.setManagerSetting(type, flag);
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_getManagerSetFlag(rootStore, type) {
  return rootStore.settingStore.getManagerSetting[type];
}

export function fn_setKitchenPrinterFlag(rootStore, viewBl) {
  rootStore.settingStore.setCheckKichenPrinter(viewBl);
  fn_bridge_shopinfo_set(rootStore);
}

//주방동시출력 사용안내
export function fn_setPayFreeType(rootStore) {
  rootStore.layerStore.setLayerAlertType("pay_free_type");
  rootStore.layerStore.setLayerAlertView(true);
}

export function fn_getKitchenPrinterFlag(rootStore) {
  return rootStore.settingStore.getCheckKichenPrinter == "Y" ? true : false;
}

export function fn_setKitchenPrinterType(rootStore, type) {
  rootStore.settingStore.setCheckKichenPrinterType(type);
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_setExceptPrintType(rootStore, type) {
  rootStore.settingStore.setCheckExceptPrintType(type);
  fn_bridge_shopinfo_set(rootStore);
}

//주방요청 메시지 등록
export function fn_requestMemoInput(rootStore, requestMemo) {
  select_access_token(rootStore).then(res => {
    if (rootStore.layerStore.getLayerRequestMemoTypeView === "kitchen") {
      requestKitchenMemoRegister(rootStore, requestMemo);
    } else {
      requestCustomerMemoRegister(rootStore, requestMemo);
    }
  });
}

//주방요청 메시지 삭제
export function fn_requestMemoDelete(rootStore, memoCd) {
  select_access_token(rootStore).then(res => {
    if (rootStore.layerStore.getLayerRequestMemoTypeView === "kitchen") {
      requestKitchenMemoDelete(rootStore, memoCd).then(r => {
        rootStore.layerStore.setLayerRequestMemoDeleteView(false);
      });
    } else {
      requestCustomerMemoDelete(rootStore, memoCd).then(r => {
        rootStore.layerStore.setLayerRequestMemoDeleteView(false);
      });
    }
  });
}

// 사운드 재생 여부
export function fn_setSoundPlay(rootStore, key, val) {
  let flag = val === "N" ? "Y" : "N";
  rootStore.settingStore.setSoundPlayCheck(key, flag);
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_getSoundPlay(rootStore) {
  return rootStore.settingStore.getSoundPlayInfo;
}

//외부프로그램 전체 자동완료 확인
export function fn_autoFlagConfirm(rootStore, viewBl) {
  if (viewBl == "all") {
    rootStore.layerStore.setLayerAlertType("all_auto_complete");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    rootStore.layerStore.setLayerAlertType("auto_complete");
    rootStore.layerStore.setLayerAlertView(true);
  }
}

//외부프로그램 전체 자동완료여부
export function fn_setOutAutoAllFlag(rootStore, viewBl) {
  rootStore.settingStore.setSettingOutAuto(viewBl);

  let allList = rootStore.settingStore.getSettingOutAutoProg;
  rootStore.settingStore.setSettingConfigUseYn(viewBl);
  outAutoUpdate(rootStore);
}

export function fn_getOutAutoAllFlag(rootStore) {
  return rootStore.settingStore.getSettingOutAuto;
}

//외부프로그램 자동완료여부
export function fn_setOutAutoFlag(rootStore, key, val) {
  rootStore.settingStore.setSettingOutAutoProgUse(rootStore, key, val);
  outAutoUpdate(rootStore);
}

//배달대행사 사용/미사용
export function fn_setDeliveryFlag(rootStore, key, val) {
  let delvList = rootStore.deliveryStore.getExpDelivery;

  let mainChkCnt = 0;
  let isChkCnt = 0;
  let arrDlv = document.getElementsByName("dlvCheck");

  delvList.map((element, index) => {
    if (element.mainUseYn == "Y" && key == element.dumaspDeliveryCode && val == "Y") {
      rootStore.settingStore.setCheckDlv(key);
      rootStore.layerStore.setLayerAlertType("dlv_setting_mainN");
      rootStore.layerStore.setLayerAlertView(true);
      mainChkCnt++;
    }
  });

  for (let i = 0; i < arrDlv.length; i++) {
    if (arrDlv[i].checked) {
      isChkCnt++;
    }
  }

  if (mainChkCnt == 0) {
    if (isChkCnt == 1 && val == "N") {
      rootStore.settingStore.setCheckDlv(key);
      rootStore.layerStore.setLayerAlertType("dlv_setting_mainY");
      rootStore.layerStore.setLayerAlertView(true);
    } else {
      fn_setDeliveryFlagSet(rootStore, key, val);
    }
  }
}

//배달대행사 사용/미사용
export function fn_setDeliveryFlagSet(rootStore, key, val, type, flag) {
  const originalList = rootStore.deliveryStore.getExpDelivery;
  const updatedList = originalList.map(item => {
    if (key === item.dumaspDeliveryCode) {
      return { ...item, use_yn: val === "N" ? "Y" : "N" };
    }
    return item;
  });

  if (type == "mainUpdate") {
    deliveryUseUpdate(rootStore, updatedList).then(res => {
      if (res) {
        if (flag == "N") {
          rootStore.settingStore.setCheckDlv("");
        }
        fn_setDlvSelected(rootStore, rootStore.settingStore.getCheckDlv);
      }
    });
  } else {
    deliveryUseUpdate(rootStore, updatedList);
  }
}

//공지사항 Detail
export function fn_detailNoticeList(rootStore) {
  let getNoticeId = rootStore.settingStore.getNoticeId;
  if (rootStore.settingStore.getNoticeList.length != 0) {
    let detail = rootStore.settingStore.getNoticeList.filter(obj => getNoticeId === obj.id)[0];
    rootStore.settingStore.setNoticeDetailList(detail);
  }
}

//new 확인
export function fn_newNoticeList(rootStore, key, val) {
  let noticeList = rootStore.settingStore.getNoticeList;
  let cnt = 0;

  noticeList.map((element, index) => {
    if (element.isNew === "Y") {
      cnt++;
    }
  });

  if (cnt > 0) {
    rootStore.settingStore.setNoticeNew("Y");
  }
}

// 완료주문 설정 view
export function fn_setMainEndView(rootStore, key, val) {
  let flag = val === "N" ? "Y" : "N";
  rootStore.settingStore.setManagerSetting("orderEnd", flag);
}

export function fn_getMainEndView(rootStore) {
  return rootStore.settingStore.getManagerSetting?.orderEnd == "Y" ? true : false;
}

//관리자 설정 초기화
export function fn_managerReset(rootStore, type) {
  rootStore.layerStore.setManagerAuthView("auth", "N");
  document.getElementById("loginId").value = "";
  document.getElementById("loginPw").value = "";
  rootStore.viewStore.setLoginAuthDetail("");
}

//프린터 추가 선택 초기화
export function fn_setPrintCheckInit(rootStore) {
  // rootStore.layerStore.setPrintAddView(false);
  document.getElementById("printNm").value = "";
  document.getElementById("port").value = "";
  document.getElementById("baudRate").value = "";
  rootStore.searchStore.setPrintAddSelectVal("portCheck", "0");
  rootStore.searchStore.setPrintAddSelectVal("baudRateCheck", "0");
}

//프린터 추가 저장
export function fn_setPrintCheckFlagSave(rootStore, type) {
  let printNmVal = document.getElementById("printNm").value;
  let portVal = document.getElementById("port").value;
  let baudRateVal = document.getElementById("baudRate").value;

  if (portVal == "" || baudRateVal == "") {
    rootStore.layerStore.setLayerAlertType("print_add_validation");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    let check = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    if (check.test(portVal)) {
      let myChar = "(";
      let charIndex = portVal.indexOf(myChar);
      portVal = portVal.slice(0, charIndex);
    }

    let addItem = {
      printerName: printNmVal,
      portNo: portVal,
      baudRate: baudRateVal,
      customerSheet: 1,
      shopSheet: 1,
      useYn: "Y",
    };
    rootStore.settingStore.setEtcPrintSettings(addItem);
    fn_bridge_shopinfo_set(rootStore);
    // rootStore.layerStore.setPrintAddView(false);
    fn_setPrintCheckInit(rootStore);
  }
}

//프린터 추가 select선택
export function fn_setPrintCheckFlag(rootStore, viewBl, type) {
  rootStore.searchStore.setPrintAddSelectVal(type, viewBl);
}


//프린트 삭제
export function fn_setPrintDelete(rootStore, index) {
  rootStore.layerStore.setLayerAlertType("print_delete");
  rootStore.layerStore.setLayerAlertView(true);
}

//출력 프린터 설정 설정 여부
export function fn_setPrintSettingFlag(rootStore, viewBl) {
  rootStore.settingStore.setCheckEtcPrinter(viewBl);
  fn_bridge_shopinfo_set(rootStore);
}

//출력 주방프린터 설정 설정 여부
export function fn_setKitchenPrintSettingFlag(rootStore, viewBl) {
  rootStore.settingStore.setCheckEtcKitchenPrinter(viewBl);
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_getPrintSettingFlag(rootStore) {
  return rootStore.settingStore.getCheckEtcPrinter == "Y" ? true : false;
}

export function fn_getKitchenPrintSettingFlag(rootStore) {
  return rootStore.settingStore.getCheckEtcKitchenPrinter == "Y" ? true : false;
}

//toggle active
export function fn_setPrintToggleActive(rootStore, viewBl, index, classNm) {
  if (
    document.getElementById(classNm + index) != null &&
    rootStore.settingStore.getEtcPrinterInfo[viewBl][index].useYn === "Y"
  ) {
    if (document.getElementById(classNm + index).classList != "active") {
      document.getElementById(classNm + index).classList.toggle("active");
    }
  } else {
    document.getElementById(classNm + index).classList.remove("active");
  }
}

//출력 프린터 item 설정 사용여부
export function fn_setPrintSettingItemFlag(rootStore, viewBl, index) {
  rootStore.settingStore.setCheckEtcPrinterDefaultItem(viewBl, index);
  fn_setPrintToggleActive(rootStore, "defaultPrintSettings", index, "print");
  fn_bridge_shopinfo_set(rootStore);
}

//출력 프린터 addItem 설정 사용여부
export function fn_setPrintSettingAddItemFlag(rootStore, viewBl, index) {
  rootStore.settingStore.setCheckEtcPrinterDefaultAddItem(viewBl, index);
  fn_setPrintToggleActive(rootStore, "addPrintSettings", index, "printAdd");
  fn_bridge_shopinfo_set(rootStore);
}

export function fn_getPrintSettingItemFlag(rootStore, index) {
  return rootStore.settingStore.getEtcPrinterInfo.defaultPrintSettings[index].useYn == "Y" ? true : false;
}

export function fn_getPrintSettingAddItemFlag(rootStore, index) {
  return rootStore.settingStore.getEtcPrinterInfo.addPrintSettings[index].useYn == "Y" ? true : false;
}

export function fn_setPrintSheetChangeDown(rootStore, key, type, index) {
  const settingStore = rootStore.settingStore;
  let val;
  if (key === "default") {
    val = settingStore.getEtcPrinterInfo.defaultPrintSettings[index][type];
    val = Number(val) - 1;
    rootStore.settingStore.setEtcPrintDefault(type, val, index);
  } else {
    val = settingStore.getEtcPrinterInfo.addPrintSettings[index][type];
    val = Number(val) - 1;
    rootStore.settingStore.setEtcPrintAdd(type, val, index);
  }

  fn_bridge_shopinfo_set(rootStore);
}

export function fn_setPrintSheetChangeUp(rootStore, key, type, index) {
  const settingStore = rootStore.settingStore;
  let val;
  if (key === "default") {
    val = settingStore.getEtcPrinterInfo.defaultPrintSettings[index][type];
    val = Number(val) + 1;
    rootStore.settingStore.setEtcPrintDefault(type, val, index);
  } else {
    val = settingStore.getEtcPrinterInfo.addPrintSettings[index][type];
    val = Number(val) + 1;
    rootStore.settingStore.setEtcPrintAdd(type, val, index);
  }
  fn_bridge_shopinfo_set(rootStore);
}

//연동배달대행사 selectBox
export function fn_getDlvSelectListView(rootStore) {
  return rootStore.settingStore.getDlvSelectListView;
}
export function fn_setDlvSelectListView(rootStore, viewBl) {
  rootStore.settingStore.setDlvSelectListView(viewBl);
}

export function fn_setDlvSelected(rootStore, tp) {
  main_dlv(rootStore, tp);
}

export function fn_getDlvSelected(rootStore) {
  let comport = rootStore.settingStore.getPrinterInfo.usedComPortForHooking;

  if (comport == "" || comport == null || comport == "null") {
    return "연결할 포트를 선택해주세요";
  }

  let list = rootStore.settingStore.getPrinterInfo.availableComPorts;
  let result = list.map((element, index) => {
    if (element.portNo == comport) {
      return element.portName;
    }
    return "";
  });

  return result;
}

export function fn_setTimeListDisabled(rootStore, key) {
  let obj = false;
  let useTimeList = rootStore.settingStore.getCookTimeList;

  for (let i = 0; i < useTimeList.length; i++) {
    if (useTimeList[i] === key) {
      obj = true;
      break;
    }
  }

  return obj;
}

export function fn_getBaeminEndOrder(rootStore) {
  return rootStore.layerStore.getLayerBaeminEndOrderView;
}

export function fn_setBaeminEndOrder(rootStore, viewBl) {
  return rootStore.layerStore.setLayerBaeminEndOrderView(viewBl);
}

export function fn_setPrintOutType(rootStore, type) {
  fn_setting_prit_receipt(rootStore, type);
  rootStore.layerStore.setPrintOutType(type);
}

// 미처리 목록 초기화
export function fn_setReturnListInit(rootStore) {
  rootStore.settingStore.setReturnFailOn("mobileOrderNo", "");
  rootStore.settingStore.setReturnFailOn("pendingNo", "");
  rootStore.settingStore.setReturnFailOn("pendingState", "");
  rootStore.layerStore.setReturnFailView(false);
}

// 미처리 주문 클릭
export function fn_return_fail_click(rootStore, item) {
  rootStore.settingStore.setReturnFailOn("mobileOrderNo", item.mobileOrderNo);
  rootStore.settingStore.setReturnFailOn("pendingNo", item.pendingNo);
  rootStore.settingStore.setReturnFailOn("pendingState", item.pendingState);
}

// 미처리 주문 클릭
export function fn_return_auto_refund(rootStore, no, type) {
  let returnList = {};
  rootStore.settingStore.getReturnFailList.map((item, index) => {
    if (item.pendingNo == no) {
      returnList = item;
    }
  });
  if (type == "list") {
    fn_return_success(rootStore, rootStore.settingStore.getReturnFailOn.pendingNo);
  } else {
    fn_bridge_order_cancel_pos(rootStore, returnList, "return");
  }
}

// 반품 처리 목록 삭제
export function fn_return_list_delete(rootStore) {
  rootStore.layerStore.setLayerAlertType("return_list_delete");
  rootStore.layerStore.setLayerAlertView(true);
}

// 요기요 휴무 상태 변경
export function fn_ygy_holiday_setting(rootStore) {
  rootStore.layerStore.setLayerAlertType("ygy_holiday");
  rootStore.layerStore.setLayerAlertView(true);
}

// 요기요 연동하기 버튼
export function fn_ygy_connect_setting(rootStore) {
  rootStore.layerStore.setYgyConnectBtn(true);
}

// 요기요 입점하기 버튼
export function fn_ygy_store_entry(rootStore) {
  rootStore.layerStore.setLayerConfirmView(false);
  analyticeEvent("setting", "settingYogiyoGoRegister", rootStore.searchStore.getShopCd); //GA4
  fn_bridge_agency_popup(rootStore, "ygyEntry");
}
//미완료 노출
export function fn_setIncompleteFlag(rootStore) {
  let flag = "";
  if (rootStore.settingStore.getProgressingExposeFlag === "Y") {
    flag = "N";
  } else {
    flag = "Y";
  }
  rootStore.settingStore.setProgressingExposeFlag(flag);
  fn_bridge_shopinfo_set(rootStore);
}
// 배민 입점하기 버튼
export function fn_bm_store_entry(rootStore) {
  rootStore.layerStore.setLayerConfirmView(false);
  analyticeEvent("setting", "settingBaeminGoRegister", rootStore.searchStore.getShopCd); //GA4
  fn_bridge_agency_popup(rootStore, "bmEntry");
}
